import React, {useContext, useEffect, useState} from 'react';
import {AppContext} from '../App';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHomeLgAlt, faCog, faGlobe } from '@fortawesome/pro-light-svg-icons';
import {faChartLine} from '@fortawesome/pro-solid-svg-icons';
// @ts-ignore
import Link from '@material-ui/core/Link';
import {BASE_URL} from '../env.json';
import useWindowSize from '../utils/windowResizeHook';
import { makeStyles } from '@material-ui/styles';
import Colors from '../styles/colors';
import {AppService} from "../services/app.service";

const BottomNav = () => {
  const context = useContext(AppContext);
  const devId = context.deviceId;
  // const userId = context.userId;
  const windowSize = useWindowSize();

  const style = makeStyles({
    root: {
        padding: 0,
    },
    bottomNav: {
      position: 'fixed',
      bottom: 0,
      height: 64,
      display: 'flex',
      width: windowSize.width,
      boxShadow: '0 0 2px 0 rgba(27, 111, 166, 0.5)',
    },
    bottomNavItem: {
      fontSize: 11,
      fontWeight:"bold",
      fontFamily: [
        'LotaGrotesque',
      ].join(','),
      flex: 1,
      color: Colors.dark,
      letterSpacing: 1,
    },
    bottomNavItemActive: {
      fontWeight:"bold",
      fontFamily: [
        'LotaGrotesque',
      ].join(','),
      flex: 1,
      color: Colors.primary,
    },
    tabLabel: {
      fontFamily: [
        'LotaGrotesque',
      ].join(','),
      fontSize: 11,
      fontWeight: "bold",
    }
  });

  const styles = style();

  // console.log(dayjs().subtract((dayjs().utcOffset()), 'm'));
  const[userIsAP, setUserIsAP] = useState<boolean>(false);

  useEffect(()=>{
    async function checkIfUserIsAnAP(){
      let appService = new AppService();
      const apCheck = await appService.checkIfUserIsAP();
      // console.log('AP Check response', apCheck.data.payload.data.user_is_ap);
      let userIsAP: boolean = false;
      if(apCheck.data.payload.data.user_is_ap) {
        userIsAP = true;
      } else {
        userIsAP = false;
      }
      setUserIsAP(userIsAP)
    }
    checkIfUserIsAnAP();
  },[])

  return (
      <BottomNavigation
          className={styles.bottomNav}
          showLabels
      >
        <BottomNavigationAction 
          component={Link}
          classes={{root: styles.root}}
          label={<span className={styles.tabLabel}>HOME</span>}
          href = {BASE_URL + "userprofile/v4/summary/" + devId}
          icon={<FontAwesomeIcon icon={faHomeLgAlt} style={{fontSize: 24, paddingBottom: 4}} />}
          className={styles.bottomNavItem}
        />

        {(userIsAP) ? ( <BottomNavigationAction
            classes={{root: styles.root}}
            label={<span className={styles.tabLabel}>REPORTS</span>}
            href = {`${BASE_URL}monitor/report-summary/${context.userId}/${context.deviceId}/`}
            icon={<FontAwesomeIcon icon={faGlobe} style={{fontSize: 24, paddingBottom: 4}} />}
            className={styles.bottomNavItem}
        />) : ''}

        <BottomNavigationAction 
          classes={{root: styles.root}}
          label={<span className={styles.tabLabel}>RECOVERY</span>}
          icon={<FontAwesomeIcon icon={faChartLine} style={{fontSize: 24, paddingBottom: 4}} />}
          className={styles.bottomNavItemActive}
        />
        <BottomNavigationAction 
          component={Link}
          classes={{root: styles.root}}
          label={<span className={styles.tabLabel}>SETTINGS</span>}
          href={BASE_URL + "userprofile/menu/" + devId}
          icon={<FontAwesomeIcon icon={faCog} style={{fontSize: 24, paddingBottom: 4}} />}
          className={styles.bottomNavItem}
        />

      </BottomNavigation>
    );
};

export default BottomNav;